import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import type { MedicationSchedulePattern } from '../types'
import {
  MEDICATION_SCHEDULE_PATTERN_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERN_URL
} from './queryConstants'

type UseMedicationSchedulePatternProps = {
  medicationId: string
  enabled?: boolean
}

type UseMedicationSchedulePatternReturn = {
  data: MedicationSchedulePattern | null
  isLoading: boolean
  refetch: () => void
}

export const useMedicationSchedulePattern = ({
  medicationId,
  enabled = true
}: UseMedicationSchedulePatternProps): UseMedicationSchedulePatternReturn => {
  const { data, isLoading, refetch } = useQuery(
    [MEDICATION_SCHEDULE_PATTERN_QUERY_KEY, medicationId],
    () =>
      getJSON({
        url: `${MEDICATION_SCHEDULE_PATTERN_URL}/${medicationId}`
      }),
    {
      enabled: enabled && !!medicationId,
      retry: 1
    }
  )

  return {
    data: (data as MedicationSchedulePattern) || null,
    isLoading,
    refetch
  }
}

export default useMedicationSchedulePattern
